import './App.css';
import React from 'react';
import UploadPage from './pages/UploadPage'

const App = () => (
  <UploadPage />
);

export default App;